import React, { useEffect, useState } from "react";
import {
    useStripe,
    useElements,
    PaymentElement,
} from "@stripe/react-stripe-js";
import { fetchPaymentIntent } from "../services/accomodationApi";
import { AiOutlineLoading } from "react-icons/ai";
import Button from "./Button/Button";
import { toast } from "react-toastify";
import { errorToast } from "../utils/errorHandling";
import { convertToSubcurrency } from "../utils/utility";
import { Trans, useTranslation } from 'react-i18next';
import { getAccommodationForm } from '../services/accomodationApi';

const Checkout = ({ amount, formData, validateAllFields, checkoutItem, transactionFee, netTotalAmount, generateValidationFields, isFull, topUp }) => {
    const { t } = useTranslation();
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = useState("");
    const [clientSecret, setClientSecret] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const createPayment = async () => {
            const id = localStorage.getItem("user_id")
                ? JSON.parse(localStorage.getItem("user_id"))
                : "0000";

            const participant_id = localStorage.getItem("participant_id")
                ? JSON.parse(localStorage.getItem("participant_id"))
                : "0000";

            const combinedFormData = {
                ...formData,
                ...checkoutItem,
                // uncommented for transaction fee removal
                // transactionFee: Number(transactionFee.toFixed(2)),
                amount: convertToSubcurrency(amount),
                netTotalAmount: netTotalAmount,
                user_id: id,
                fk_participants_id: participant_id,
                payment_type: topUp ? "Top-Up" : "Payment"
            };
            try {
                const data = await fetchPaymentIntent(combinedFormData);
                if (data) {
                    setClientSecret(data.clientSecret);
                }
            } catch (error) {
                console.log(error);
            }
        };
        createPayment();
    }, [amount]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            if (!topUp) {
                const data = await getAccommodationForm();
                if (data) {
                    toast.error(t("Checkout.ExistRecord"));
                    setIsSubmitting(false);
                    return;
                }
            }
        } catch (error) {
            console.log(error);
        }

        // Ensure Stripe.js has loaded
        if (!stripe || !elements) {
            toast.error(t("Checkout.Stripe"));
            setIsSubmitting(false);
            return;
        }
        try {
            let validationFields = generateValidationFields();
            if (validateAllFields(formData, validationFields)) {
                const isRoomFull = await isFull();
                if (isRoomFull) {
                    setIsSubmitting(false);
                    toast.error(t("accomodation.RoomUnavailable"));
                    return;
                }
                // Step 1: Confirm payment
                const { error: submitError } = await elements.submit();
                if (submitError) {
                    toast(submitError);
                    return;
                }

                const paymentResult = await stripe.confirmPayment({
                    elements,
                    clientSecret,
                    confirmParams: {
                        return_url: `https://shineling.org/retreat-my/payment-success`,
                    }
                });
                // return_url: `https://shineling.org/retreat-my/payment-success?amount=${amount}`,
                // Handle payment errors
                if (paymentResult.error) {
                    if (paymentResult.error.type === "card_error" || paymentResult.error.type === "validation_error") {
                        toast.error(paymentResult.error.message);
                    } else {
                        toast.error(t("Checkout.PaymentError"));
                    }
                    console.error(paymentResult.error);
                    setIsSubmitting(false);
                    setErrorMessage(paymentResult.error.message)
                    return;
                }

                // Step 2: Check payment status
                if (paymentResult.paymentIntent?.status !== "succeeded") {
                    toast.error(t("Checkout.FailedPayment"));
                    setIsSubmitting(false); // Re-enable the button
                    return;
                }

            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };

    if (!clientSecret || !stripe || !elements) {
        return (
            <div className="d-flex justify-content-center">
                <AiOutlineLoading className="spin" />
            </div>
        )
    }

    return (
        <>
            <div>
                {clientSecret &&
                    <>
                        <PaymentElement className="mb-3" />
                        {errorMessage && <div>{errorMessage}</div>}
                        <Trans>{t("Checkout.Reminder")}</Trans>
                        <p className="error">{t("Checkout.Reminder2")}</p>
                        <Button buttonStyle="btn--primary" onClick={handleSubmit} disabled={!stripe || isSubmitting} type="button">
                            {isSubmitting ? <AiOutlineLoading className="spin" /> : `${t("Checkout.CheckOut")} MYR ${amount}`}
                        </Button>
                    </>
                }
            </div>

        </>
    );
}

export default Checkout;
